<template>
  <v-navigation-drawer
    temporary
    app
    :value="modalCart"
    right
    hide-overlay
    width="500"
  >
    <v-card class="rounded-lg" elevation="0">
      <v-toolbar flat>
        <v-card-title> Eventos </v-card-title>
        <v-spacer></v-spacer>
        <v-btn class="mt-0 mr-0" icon @click="toggleCartModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text
        v-for="(prod, index) in products"
        :key="index"
        class="ml-2"
        style="position: relative; overflow: hidden"
      >
        <v-row class="pb-4">
          <v-col cols="3">
            <v-img
              :src="prod.img"
              width="160"
              height="120"
              class="rounded-lg"
            />
          </v-col>
          <v-col cols="8" class="d-flex flex-column text-left px-0">
            <div
              v-if="prod.status == 'ESGOTADO'"
              class="sold-out-event elevation-3"
            >
              Esgotado
            </div>
            <span class="text-subtitle-1 font-weight-bold">
              {{ prod.descricao }}</span
            >
            {{
              formatProductDate(prod.dthr_apresentacao) ||
              formatProductDate(prod.date)
            }}
            {{ prod.hour ? " - " + prod.hour : "" }}
            <template v-if="checkQuantityPossibilities(prod)">
              <template
                v-for="(
                  variation, indexVariation
                ) in prod.quantityPossibilities"
              >
                <span
                  v-if="variation.quantity > 0"
                  :key="indexVariation"
                  class="text-body-2"
                >
                  <div
                    v-if="variation.status === 'ESGOTADO'"
                    class="sold-out-event elevation-3"
                  >
                    Esgotado
                  </div>
                  {{ variation.quantity }} x {{ variation.descricao }} -
                  {{ formatCurrency(variation.variationPrice) }}
                </span>
              </template>
            </template>
            <template>
              <span class="text-body-2">
                {{ prod.quantityIfOnlyQuantity }} x
                {{
                  formatCurrency(prod.total / prod.quantityIfOnlyQuantity) ||
                  "R$ 0,00"
                }}
              </span>
            </template>
            <span class="text-body-2 font-weight-bold mt-2"
              >Subtotal: {{ formatCurrency(prod.total) || "R$ 0,00" }}</span
            >
          </v-col>
          <v-col cols="1" class="pa-0 pt-3">
            <v-btn icon color="error" @click="removeProduct(prod)">
              <v-icon> mdi-delete-outline </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="rounded-lg"
          color="error"
          v-if="hasProducts"
          text
          @click="deleteAllProducts = true"
          >Remover todos os eventos<v-icon class="ml-2"
            >mdi-delete-outline</v-icon
          >
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm-modal
      v-model="deleteProduct"
      @confirm="remove()"
      :message="productToRemove.descricao"
      @cancel="deleteProduct = false"
      title="Confirmação"
      subtitle="Tem certeza de que deseja remover o evento?"
    />
    <confirm-modal
      v-model="deleteAllProducts"
      @confirm="removeAllProducts()"
      @cancel="deleteAllProducts = false"
      title="Confirmação"
      subtitle="Tem certeza de que deseja remover todos os eventos?"
    />
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { formatCurrency, formatProductDate } from "@/utils/productPackage.js";
import confirmModal from "@/components/global/newConfirmDialog.vue";

export default {
  name: "productCart",
  data: () => ({
    formatCurrency,
    formatProductDate,
    deleteProduct: false,
    deleteAllProducts: false,
    productToRemove: {},
  }),
  components: {
    confirmModal,
  },
  computed: {
    ...mapGetters({ products: "getCart", modalCart: "modalCart" }),
    hasProducts() {
      return this.products.length > 0;
    },
  },
  methods: {
    ...mapActions([
      "toggleCartModal",
      "removeProductFromCart",
      "removeAllProductsFromCart",
    ]),
    shouldShowProduct(prod) {
      if (prod && prod.quantityPossibilities && prod.quantityPossibilities[0]) {
        return (
          prod.quantityPossibilities[0].quantity === 0 &&
          prod.quantityIfOnlyQuantity > 0
        );
      }
      return false;
    },
    checkQuantityPossibilities(prod) {
      if (prod && prod.quantityPossibilities) {
        return prod.quantityPossibilities.length > 0;
      }
      return false;
    },
    removeAllProducts() {
      this.removeAllProductsFromCart();
      this.deleteAllProducts = false;
      this.toggleCartModal();
    },
    removeProduct(prod) {
      this.productToRemove = prod;
      this.deleteProduct = true;
    },
    remove() {
      this.removeProductFromCart(this.productToRemove);
      this.deleteProduct = false;
      if (this.products.length === 0) {
        this.toggleCartModal();
      }
    },
  },
};
</script>
<style scoped>
.sold-out-event {
  position: absolute;
  top: 0.5rem;
  left: -1.5rem;
  background-color: #f44336;
  color: #fff;
  padding: 2px 28px;
  margin-top: 10px;
  font-size: 15px;
  font-weight: bold;
  border-radius: 4px;
  transform: rotate(-45deg);
}
</style>
